export enum NodeEventType {
    ACTION = "ACTION",
    MENU_INCOMING = "MENU_INCOMING",
    MENU_OUTGOING = "MENU_OUTGOING"
}

export interface NodeEvent {
    nodeEventType: NodeEventType;
}

export interface CurrentStep {
    step: string;
    nextStep: string;
    nextFlow: string;
    eventType: string;
    nodeType: string;
    node: NodeEvent;
}

export interface FlowEvent {
    emulatorId: string;
    sessionId: string;
    flowId: string;
    currentStep: CurrentStep;
    timestamp: string;
    variables?: Map<String, Object>[];
}


